<app-header *ngIf="isShowHeader"></app-header>
<app-side-bar *ngIf="isShowSidenav"></app-side-bar>
<div class="main-content-wrapper"
     [class.main-content-has-header]="isShowHeader"
     [class.main-content-sidebar-expanded]="isShowSidenav && !isSidebarCollapsed"
     [class.main-content-sidebar-collapsed]="isShowSidenav && isSidebarCollapsed">
    <router-outlet></router-outlet>
    <app-main-drawer></app-main-drawer>
</div>